import {constants} from '../../constants';
import {GlobalAnalyticsVariablesInterface} from '../interfaces';
import {retrieveMergeResponseGlobalVarsCase} from './retrieve-merge-response-global-vars.case';

export const trackOlciFlowPayloadCase = (
  payload: any,
  globalVariables?: GlobalAnalyticsVariablesInterface,
  loggedInPaxId?: string,
): GlobalAnalyticsVariablesInterface => {
  const data = Object.assign({}, payload);
  if (!data.passengerId) {
    data.passengerId = loggedInPaxId ?? constants.DEFAULT_GUEST_ID_FOR_TRACKING.ID;
  }
  return retrieveMergeResponseGlobalVarsCase(true, data, globalVariables);
}
